import { render, staticRenderFns } from "./DateInputs.vue?vue&type=template&id=ec96f948&"
import script from "./DateInputs.vue?vue&type=script&lang=js&"
export * from "./DateInputs.vue?vue&type=script&lang=js&"
import style0 from "./DateInputs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports